const ENDPOINTS = {
		
	GET_PAISES: () => 
		'/api/v1/paises'
};

export default ENDPOINTS;